import { render, staticRenderFns } from "./NewsInformation.vue?vue&type=template&id=34afb568&scoped=true"
import script from "./NewsInformation.vue?vue&type=script&lang=js"
export * from "./NewsInformation.vue?vue&type=script&lang=js"
import style0 from "./NewsInformation.vue?vue&type=style&index=0&id=34afb568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34afb568",
  null
  
)

export default component.exports